<template>
  <div class="address">
    <form action="" class="address--form" v-if="edit_show">
      <a @click.prevent="edit_show = false" href="" class="address--form-close">
        <font-awesome-icon icon="times-circle" />
      </a>
      <div>
        <div class="in1">
          <div class="bo1">
            <label class="la" for="">استان *</label>
            <multiselect
              v-model="eddit.pri"
              :options="options_city"
              placeholder="استان"
              label="name"
              track-by="name"
              :searchable="true"
              :taggable="true"
            >
            </multiselect>
          </div>
          <div class="bo">
            <label class="la" for="">شهر *</label>
            <input v-model="eddit.city" type="text" placeholder="شهر" />
          </div>
        </div>
        <label class="la" for="">نشانی *</label>
        <input
          style="margin-bottom: 0.5em"
          v-model="eddit.add"
          placeholder="نشانی"
          type="text"
        />
        <!-- <input type="text" /> -->
        <div class="in2">
          <div class="b3">
            <label class="la" for="">کد پستی *</label>
            <input
              class="i3"
              type="text"
              v-model="eddit.zipc"
              placeholder="کد پستی"
            />
          </div>
        </div>
        <hr class="rrrr" />
        <div class="in3">
          <div class="i7">
            <label class="la" for="">نام گیرنده *</label>
            <input
              class="b4"
              v-model="eddit.fname"
              placeholder="نام گیرنده"
              type="text"
            />
          </div>
          <div class="i7">
            <label class="la" for="">نام خانوادگی گیرنده *</label>
            <input
              class="b4"
              v-model="eddit.lname"
              placeholder="نام خانوادگی گیرنده"
              type="text"
            />
          </div>
          <div class="i7">
            <label class="la" for="">کدملی </label>
            <input
              class="b4"
              v-model="eddit.nanu"
              placeholder="کدملی"
              type="text"
            />
          </div>
          <div class="i7">
            <label class="la" for="">شماره موبایل *</label>
            <input
              class="b4"
              v-model="eddit.pho"
              placeholder="شماره موبایل"
              type="text"
            />
          </div>
          <div class="i8">
            <label class="la" for=""> تلفن ثابت به همراه کد شهر *</label>
            <input
              class="b5"
              v-model="eddit.tel"
              placeholder=" تلفن ثابت به همراه کد شهر"
              type="text"
            />
          </div>
          <hr class="rrrr" />
          <button @click.prevent="edit_add" class="bbb">ویرایش نشانی</button>
        </div>
      </div>
    </form>
    <form action="" class="address--form" v-if="create_show">
      <a
        @click.prevent="create_show = false"
        href=""
        class="address--form-close"
      >
        <font-awesome-icon icon="times-circle" />
      </a>
      <div>
        <div class="in1">
          <div class="bo1">
            <label class="la" for="">استان *</label>
            <multiselect
              v-model="create.pri"
              :options="options_city"
              placeholder="استان"
              label="name"
              track-by="name"
              :searchable="true"
              :taggable="true"
            >
            </multiselect>
          </div>
          <div class="bo">
            <label class="la" for="">شهر *</label>
            <input type="text" v-model="create.city" placeholder="شهر" />
          </div>
        </div>
        <label class="la" for="">نشانی *</label>
        <input
          style="margin-bottom: 0.5em"
          v-model="create.add"
          placeholder="نشانی"
          type="text"
        />
        <!-- <input type="text" /> -->
        <div class="in2">
          <div class="b3">
            <label class="la" for="">کد پستی *</label>
            <input
              class="i3"
              v-model="create.zipc"
              type="text"
              placeholder="کد پستی"
            />
          </div>
        </div>
        <hr class="rrrr" />
        <div class="in3">
          <div class="i7">
            <label class="la" for="">نام گیرنده *</label>
            <input
              class="b4"
              v-model="create.fname"
              placeholder="نام گیرنده"
              type="text"
            />
          </div>
          <div class="i7">
            <label class="la" for="">نام خانوادگی گیرنده *</label>
            <input
              class="b4"
              v-model="create.lname"
              placeholder="نام خانوادگی گیرنده"
              type="text"
            />
          </div>
          <div class="i7">
            <label class="la" for="">کدملی</label>
            <input
              class="b4"
              v-model="create.nanu"
              placeholder="کد ملی"
              type="text"
            />
          </div>
          <div class="i7">
            <label class="la" for="">شماره موبایل *</label>
            <input
              class="b4"
              v-model="create.pho"
              placeholder="شماره موبایل"
              type="text"
            />
          </div>
          <div class="i8">
            <label class="la" for=""> تلفن ثابت به همراه کد شهر *</label>
            <input
              class="b5"
              v-model="create.tel"
              placeholder=" تلفن ثابت به همراه کد شهر"
              type="text"
            />
          </div>
          <hr class="rrrr" />
          <button class="bbb" @click.prevent="create__address">
            ایجاد نشانی جدید
          </button>
        </div>
      </div>
    </form>
    <div class="address__container">
      <h3 class="address__container--title">نشانی ها</h3>
      <div
        class="address__container--cart"
        :key="(item, index)"
        v-for="(item, index) in list"
      >
        <div @click="delete_add" class="address__container--cart--delete">
          <font-awesome-icon icon="trash" />
          <input type="hidden" :value="item.id" />
        </div>
        <p class="address__container--cart--adress">
          {{ item.address }}
        </p>
        <div class="address__container--cart--city">
          <font-awesome-icon icon="search" />
          <p class="address__container--cart--city-province">
            {{ item.get_province_display }}
          </p>
          &nbsp; ، &nbsp;
          <p class="address__container--cart--city-city">
            {{ item.city }}
          </p>
        </div>
        <p class="address__container--cart--zipcode">
          <font-awesome-icon icon="search" />
          {{ item.zip_code.toPersianDigits() }}
        </p>
        <p class="address__container--cart--zipcode">
          <font-awesome-icon icon="search" />
          {{ item.cellphone.toPersianDigits() }}
        </p>
        <p class="address__container--cart--name">
          <font-awesome-icon icon="search" />
          {{ item.first_name }} {{ item.last_name }}
        </p>
        <a
          @click.prevent="open_edit"
          href=""
          class="address__container--cart--btn"
        >
          ویرایش نشانی &nbsp; &rsaquo;
          <input type="hidden" :value="item.id" />
        </a>
      </div>
      <button
        v-if="list.length < 3"
        @click="create_show = true"
        class="address__container--btn"
      >
        <font-awesome-icon icon="search" />
        افزودن آدرس جدید
      </button>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
export default {
  data() {
    return {
      d_id: "",
      list: [],
      create: {
        tel: "",
        fname: "",
        lname: "",
        zipc: "",
        pri: [],
        city: "",
        add: "",
        pla: "",
        vah: "",
        nanu: "",
        pho: "",
      },
      eddit: {
        tel: "",
        fname: "",
        lname: "",
        zipc: "",
        pri: [],
        city: "",
        add: "",
        pla: "",
        vah: "",
        nanu: "",
        pho: "",
      },
      create_show: false,
      edit_show: false,
      value: "",
      options_city: [
        { id: 1, name: "آذربایجان شرقی" },
        { id: 2, name: "آذربایجان غربی" },
        { id: 3, name: "اردبیل" },
        { id: 4, name: "اصفهان" },
        { id: 5, name: "البرز" },
        { id: 6, name: "ایلام" },
        { id: 7, name: "بوشهر" },
        { id: 8, name: "تهران" },
        { id: 9, name: "چهارمحال و بختیاری" },
        { id: 10, name: "خراسان جنوبی" },
        { id: 11, name: "خراسان رضوی" },
        { id: 12, name: "خراسان شمالی" },
        { id: 13, name: "خوزستان" },
        { id: 14, name: "زنجان" },
        { id: 15, name: "سمنان" },
        { id: 16, name: "سیستان و بلوچستان" },
        { id: 17, name: "فارس" },
        { id: 18, name: "قزوین" },
        { id: 19, name: "قم" },
        { id: 20, name: "کردستان" },
        { id: 21, name: "کرمان" },
        { id: 22, name: "کرمانشاه" },
        { id: 23, name: "کهگیلویه و بویراحمد" },
        { id: 24, name: "گلستان" },
        { id: 25, name: "گیلان" },
        { id: 26, name: "لرستان" },
        { id: 27, name: "مازندران" },
        { id: 28, name: "مرکزی" },
        { id: 29, name: "هرمزگان" },
        { id: 30, name: "همدان" },
        { id: 31, name: "یزد" },
      ],
    };
  },
  methods: {
    edit_add() {
      var that = this;
      that.$store.state.load = true;
      if (
        this.eddit.tel.length == 0 ||
        this.eddit.pho.length == 0 ||
        this.eddit.pri.length == 0 ||
        this.eddit.city.length == 0 ||
        this.eddit.add.length == 0 ||
        this.eddit.zipc.length == 0 ||
        this.eddit.fname.length == 0 ||
        this.eddit.lname.length == 0
      ) {
        that.$toastr.e("لطفا فیلد های ضروری را پر کنید.");
        that.$store.state.load = false;
      } else if (this.eddit.pho.length <= 11 && this.eddit.pho.length >= 15) {
        that.$toastr.e("لطفا شماره همراه معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.eddit.tel.length != 11) {
        that.$toastr.e("لطفا شماره ثابت معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.eddit.city.length >= 127) {
        that.$toastr.e("طول نام شهر وارد شده نباید بیشتر از ۱۵۰ حرف باشد.");
        that.$store.state.load = false;
      } else if (this.eddit.zipc.length != 10) {
        that.$toastr.e("لطفا کد پستی معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.eddit.nanu.length != 10 && this.eddit.nanu.length != 0) {
        that.$toastr.e("لطفا کد ملی معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.eddit.fname.length >= 150) {
        that.$toastr.e("طول نام وارد شده نباید بیشتر از ۱۵۰ حرف باشد.");
        that.$store.state.load = false;
      } else if (this.eddit.lname.length >= 150) {
        that.$toastr.e(
          "طول نام خانوادگی وارد شده نباید بیشتر از ۱۵۰ حرف باشد."
        );
        that.$store.state.load = false;
      } else {
        $.ajax({
          url: that.$store.state.url + "api/v1/accounts/adr/" + this.d_id + "/",
          crossDomain: true,
          headers: {
            Authorization: "Bearer" + " " + localStorage.getItem("profile"),
          },
          xhrFields: {
            withCredentials: true,
          },
          data: {
            phone: this.eddit.tel,
            cellphone: this.eddit.pho,
            province: this.eddit.pri.id,
            city: this.eddit.city,
            address: this.eddit.add,
            zip_code: this.eddit.zipc,
            first_name: this.eddit.fname,
            last_name: this.eddit.lname,
            national_no: this.eddit.nanu,
          },
          type: "PATCH",
          success: function (data, textStatus, request) {
            that.$toastr.s(data);
            $.ajax({
              url: that.$store.state.url + "api/v1/accounts/adr/",
              crossDomain: true,
              headers: {
                Authorization: "Bearer" + " " + localStorage.getItem("profile"),
              },
              xhrFields: {
                withCredentials: true,
              },
              type: "GET",
              success: function (data, textStatus, request) {
                // console.log(data);
                that.list = data;
                that.$store.state.load = false;
                that.edit_show = false;
              },
              error: function (request, textStatus, errorThrown) {
                if (request.state == 500) {
                  that.$toastr.e("خطایی در سرور به وجود امده");
                  that.$store.state.e500 = true;
                } else {
                  that.$store.state.e404 = true;
                  that.$toastr.e("خطا در برقراری ارتباط");
                }
              },
              complete: function () {},
            });
          },
          error: function (request, textStatus, errorThrown) {
            for (var i = 0; i < request.responseJSON.length; i++) {
              that.$toastr.e(request.responseJSON[i]);
            }
            // console.log(request);
          },
          complete: function () {
            that.$store.state.load = false;
          },
        });
      }
    },
    open_edit(e) {
      var that = this;
      this.edit_show = true;
      // console.log(e.target.firstElementChild.value);
      this.d_id = e.target.firstElementChild.value;
      that.$store.state.load = true;
      $.ajax({
        url: that.$store.state.url + "api/v1/accounts/adr/" + this.d_id + "/",
        crossDomain: true,
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        xhrFields: {
          withCredentials: true,
        },
        type: "GET",
        success: function (data, textStatus, request) {
          // console.log(data);

          that.eddit.nanu = data.national_no;
          that.eddit.add = data.address;
          that.eddit.pho = data.cellphone;
          that.eddit.city = data.city;
          that.eddit.fname = data.first_name;
          that.eddit.lname = data.last_name;
          that.eddit.tel = data.phone;
          that.eddit.zipc = data.zip_code;
          var boom = data.province;
          // console.log(data.province, "province");
          for (var h = 1; h < that.options_city.length; h++) {
            if (boom == h) {
              that.eddit.pri = that.options_city[h - 1];
              console.log(boom, "            ", h, that.options_city[h - 1]);
            }
          }
          that.$store.state.load = false;
        },
        error: function (request, textStatus, errorThrown) {
          if (request.state == 500) {
            that.$toastr.e("خطایی در سرور به وجود امده");
            that.$store.state.e500 = true;
          } else {
            that.$store.state.e404 = true;
            that.$toastr.e("خطا در برقراری ارتباط");
          }
        },
        complete: function () {},
      });
    },
    delete_add(e) {
      var id = e.target.lastChild.value;
      var that = this;
      // console.log(this.create);
      var that = this;
      that.$store.state.load = true;
      $.ajax({
        url: that.$store.state.url + "api/v1/accounts/adr/" + id + "/",
        crossDomain: true,
        headers: {
          Authorization: "Bearer" + " " + localStorage.getItem("profile"),
        },
        xhrFields: {
          withCredentials: true,
        },
        type: "DELETE",
        success: function (data, textStatus, request) {
          that.$toastr.s(data);
          $.ajax({
            url: that.$store.state.url + "api/v1/accounts/adr/",
            crossDomain: true,
            headers: {
              Authorization: "Bearer" + " " + localStorage.getItem("profile"),
            },
            xhrFields: {
              withCredentials: true,
            },
            type: "GET",
            success: function (data, textStatus, request) {
              // console.log(data);
              that.list = data;
            },
            error: function (request, textStatus, errorThrown) {
              if (request.state == 500) {
                that.$toastr.e("خطایی در سرور به وجود امده");
                that.$store.state.e500 = true;
              } else {
                that.$store.state.e404 = true;
                that.$toastr.e("خطا در برقراری ارتباط");
              }
            },
            complete: function () {
              that.$store.state.load = false;
            },
          });
        },
        error: function (request, textStatus, errorThrown) {
          // console.log(request);
        },
        complete: function () {
          that.$store.state.load = false;
        },
      });
    },
    create__address() {
      // console.log(this.create);
      var that = this;
      that.$store.state.load = true;
      if (
        this.create.tel.length == 0 ||
        this.create.pho.length == 0 ||
        this.create.pri.length == 0 ||
        this.create.city.length == 0 ||
        this.create.add.length == 0 ||
        this.create.zipc.length == 0 ||
        this.create.fname.length == 0 ||
        this.create.lname.length == 0
      ) {
        that.$toastr.e("لطفا فیلد های ضروری را پر کنید.");
        that.$store.state.load = false;
      } else if (this.create.pho.length <= 11 && this.create.pho.length >= 15) {
        that.$toastr.e("لطفا شماره همراه معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.create.tel.length != 11) {
        that.$toastr.e("لطفا شماره ثابت معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.create.city.length >= 127) {
        that.$toastr.e("طول نام شهر وارد شده نباید بیشتر از ۱۵۰ حرف باشد.");
        that.$store.state.load = false;
      } else if (this.create.zipc.length != 10) {
        that.$toastr.e("لطفا کد پستی معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (
        this.create.nanu.length != 10 &&
        this.create.nanu.length != 0
      ) {
        that.$toastr.e("لطفا کدملی معتبر وارد کنید.");
        that.$store.state.load = false;
      } else if (this.create.fname.length >= 150) {
        that.$toastr.e("طول نام وارد شده نباید بیشتر از ۱۵۰ حرف باشد.");
        that.$store.state.load = false;
      } else if (this.create.lname.length >= 150) {
        that.$toastr.e(
          "طول نام خانوادگی وارد شده نباید بیشتر از ۱۵۰ حرف باشد."
        );
        that.$store.state.load = false;
      } else {
        $.ajax({
          url: that.$store.state.url + "api/v1/accounts/adr/",
          crossDomain: true,
          headers: {
            Authorization: "Bearer" + " " + localStorage.getItem("profile"),
          },
          xhrFields: {
            withCredentials: true,
          },
          data: {
            phone: this.create.tel,
            cellphone: this.create.pho,
            province: this.create.pri.id,
            city: this.create.city,
            address: this.create.add,
            zip_code: this.create.zipc,
            first_name: this.create.fname,
            last_name: this.create.lname,
            national_no: this.create.nanu,
          },
          type: "POST",
          success: function (data, textStatus, request) {
            that.$toastr.s(data);
            $.ajax({
              url: that.$store.state.url + "api/v1/accounts/adr/",
              crossDomain: true,
              headers: {
                Authorization: "Bearer" + " " + localStorage.getItem("profile"),
              },
              xhrFields: {
                withCredentials: true,
              },
              type: "GET",
              success: function (data, textStatus, request) {
                // console.log(data);
                that.list = data;
                that.$store.state.load = false;
                that.create_show = false;
              },
              error: function (request, textStatus, errorThrown) {
                if (request.state == 500) {
                  that.$toastr.e("خطایی در سرور به وجود امده");
                  that.$store.state.e500 = true;
                } else {
                  that.$store.state.e404 = true;
                  that.$toastr.e("خطا در برقراری ارتباط");
                }
              },
              complete: function () {},
            });
          },
          error: function (request, textStatus, errorThrown) {
            for (var i = 0; i < request.responseJSON.length; i++) {
              that.$toastr.e(request.responseJSON[i]);
            }
          },
          complete: function () {
            that.$store.state.load = false;
          },
        });
      }
    },
  },
  created() {
    String.prototype.toPersianDigits = function () {
      var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      return this.replace(/[0-9]/g, function (w) {
        return id[+w];
      });
    };
    var that = this;
    that.$store.state.load = true;
    $.ajax({
      url: that.$store.state.url + "api/v1/accounts/adr/",
      crossDomain: true,
      headers: {
        Authorization: "Bearer" + " " + localStorage.getItem("profile"),
      },
      xhrFields: {
        withCredentials: true,
      },
      type: "GET",
      success: function (data, textStatus, request) {
        // console.log(data);
        that.list = data;
        that.$store.state.load = false;
      },
      error: function (request, textStatus, errorThrown) {
        // console.log("blue");
      },
      complete: function () {},
    });
  },
  components: {
    Multiselect,
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
.in3 {
  margin-top: 1em;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  .i7 {
    width: 49%;
    margin-bottom: 0.5em;
  }
  .i8 {
    width: 100%;
    margin-bottom: 0.5em;
  }
}
.in2 {
  display: flex;
  margin-bottom: 0.5em;

  .b1 {
    width: 20%;
    margin-left: 0.5em;
  }
  .b2 {
    width: 20%;
    margin-left: 0.5em;
  }
  .b3 {
    width: 100%;
    // margin-left: 0.5em;
  }
  input {
    width: 35%;
  }
}
.in1 {
  width: 100%;
  display: flex;
  //   background: red;
  justify-content: center;
  align-items: flex-end;
  margin-bottom: 0.5em;
  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
  .bo1 {
    // background: blue;ZZ
    width: 50%;
    // margin: 0.6em;
    @media screen and (max-width: 500px) {
      width: 100%;
    }
  }
  .bo {
    // background: red;
    margin-bottom: 0.05em;
    width: 50%;
    margin-right: 0.5em;
    @media screen and (max-width: 500px) {
      width: 100%;
    }
  }
}
.la {
  //   color: red;
  font-size: 0.8em;
  display: block;
  padding-bottom: 0.5em;
}
.address {
  margin-top: 7.9em;
  width: 100%;
  min-height: 0vh;
  display: flex;
  justify-content: center;
  //   align-items: center;
  //   background: red;
  @media screen and (max-width: 500px) {
    font-size: 0.9em;
  }
  &--form {
    position: fixed;
    width: 600px;
    height: 650px;
    overflow-y: visible;
    overflow-x: hidden;
    background: var(--main-color);
    padding: 3em 3em;
    z-index: 900;
    top: 1%;
    box-shadow: 0 0 400px 400px rgba(0, 0, 0, 0.103);
    border-radius: 8px;
    direction: rtl;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 500px) {
      font-size: 1em;
      width: 99%;
      height: 90vh;
      top: 50%;
      padding: 10em 1em 2em 1em;
      // padding-top: 7em;
      transform: translate(0, -50%);
    }
    input {
      background: var(--main-color);
      border: 1px solid rgba(204, 204, 204, 0.39);
      padding: 0.53em;
      width: 100%;
      border-radius: 5px;
      font-family: "yekan";
      color: var(--font-color);
      //   margin-bottom: ;
      @media screen and (max-width: 500px) {
        font-size: 1em;
        // width: 90%;
        // min-height: 10vh;
      }
    }
    &-close {
      position: absolute;
      left: 0;
      top: 0;
      transform: translate(50%, 30%);
      font-size: 2em;
      color: var(--shrink);
    }
  }
  &__container {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.13);
    border: 1px solid rgb(202, 213, 214);
    border-radius: 8px;
    padding: 3em;
    direction: rtl;
    margin-top: 2em;

    width: 90%;
    min-height: 100px;
    background: var(--main-color);
    &--btn {
      cursor: pointer;
      border: none;
      background: transparent;
      font-family: "yekan";
      padding: 1em 2em;
      display: block;
      margin-top: 1em;
      margin-bottom: -2em;
      @media screen and (max-width: 500px) {
        font-size: 1em;
        margin-top: 0.5em;
        padding: 1em;
      }
      svg {
        margin-left: 0.5em;
      }
    }
    &--title {
      //   font-family: "lalezar";
      width: 100%;
      border-bottom: 1px solid var(--sub-color);
      padding-bottom: 1em;
    }
    &--cart {
      //   background: red;
      border-bottom: 1px solid rgb(202, 213, 214);
      padding: 2em;
      position: relative;
      &--delete {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translate(0%, -40%);
        width: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        border-radius: 50%;
        box-shadow: 0 0 1px rgba(0, 0, 0, 0.123);
        color: var(--main-color);
        background: var(--sub-color);
        cursor: pointer;
        svg {
          pointer-events: none;
        }
      }
      &--adress {
        color: black;
        font-weight: 600;
        margin-bottom: 1em;
      }
      &--zipcode {
        display: flex;
        color: var(--font-color);
        font-size: 0.9em;
        margin-bottom: 0.5em;
        svg {
          margin-top: 0.4em;
          margin-left: 0.5em;
        }
      }
      &--city {
        display: flex;
        color: var(--font-color);
        font-size: 0.9em;
        margin-bottom: 0.5em;
        svg {
          margin-top: 0.4em;
          margin-left: 0.5em;
        }
        // background: red;
      }
      &--btn {
        // background: red;
        display: block;
        text-decoration: none;
        padding-top: 0.5em;
        color: var(--shrink);
      }
      &--name {
        display: flex;
        color: var(--font-color);
        font-size: 0.9em;
        margin-bottom: 0.5em;
        svg {
          margin-top: 0.4em;
          margin-left: 0.5em;
        }
      }
    }
  }
}
.rrrr {
  //   margin-bottom: 1em;
  margin: 0 auto;
  width: 100%;
  border: none;
  height: 1px;
  margin-top: 1em;
  background-color: #cfd8dc;
}
.bbb {
  display: block;
  width: 100%;
  border: none;
  color: var(--main-color);
  background: var(--sub-color);
  padding: 1em;
  font-family: "yekan";
  margin-top: 2em;
  border-radius: 8px;
  @media screen and (max-width: 500px) {
    font-size: 0.8em;
    margin-bottom: 3em;
    // width: 90%;
    // min-height: 10vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/userDetail/adress.vue